import {Component, Input, Optional} from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';


@Component({
    selector: 'app-layout-title',
    template: `
    <div [ngClass]="{'modal-header alert-info':isModal}">
      <!--<hr class="mt-2">-->
      <h3 [ngClass]="{'mt-3 mb-4':!isModal}">{{ title | translate}} {{ subTitle | translate }}</h3>

      <button *ngIf="isModal" type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    `,
    standalone: false
})
export class LayoutTitleComponent {

  constructor(@Optional() public modalRef: BsModalRef) {}

  @Input() title = 'Please set a title';

  @Input() subTitle = '';

  @Input() isModal = false;

}

